import module from './module.js'

//Componentes
import './components/component.js'
import './components/lista/component.js'
import './components/agregar/component.js'

//Rutas
import './routes/agregar.js'
import './routes/lista.js'
import './routes/usuarios.js'

//Servicios
import './services/Usuarios.js'
import './services/Catalogos/Departamentos.js'
import './services/Catalogos/Puestos.js'
import './services/Catalogos/Master.js'

export default module.name



// WEBPACK FOOTER //
// ./src/usuarios/index.js